import {wrap} from '../../shared/loading-overlay'
;(function module() {
  angular.module('app.ui.form.ctrls').controller('PositionListingController', [
    '$window',
    'PositionApi',
    '$sce',
    '$uibModal',
    '$log',
    'logger',
    `$scope`,
    'SharedApi',
    'userService',
    'CandidateProfileApi',
    'ApplicationsApi',
    'socket',
    '$rootScope',
    '$timeout',
    '$location',
    function controller(
      $window,
      PositionApi,
      $sce,
      $uibModal,
      $log,
      logger,
      $scope,
      SharedApi,
      userService,
      CandidateProfileApi,
      ApplicationsApi,
      socket,
      $rootScope,
      $timeout,
      $location
    ) {
      let vm = this

      socket.on('POSITION_CREATE', async positionId => {
        const {data: newPosition} = await PositionApi.getPositionListing({
          id: positionId,
        })

        const formatPosition = await setGridData(newPosition, vm, $window)

        vm.positionListing = [...vm.positionListing, ...formatPosition]
        vm.gridOptions.api.updateRowData({
          addIndex: vm.positionListing.length,
          add: formatPosition,
        })
        updateGridGroupPipeline()
      })
      socket.on('POSITION_UPDATE', async positionId => {
        const {data: updatedPosition} = await PositionApi.getPositionListing({
          id: positionId,
        })

        const formatUpdatedPosition = await setGridData(
          updatedPosition,
          vm,
          $window
        )

        const updatePositionIndex = vm.positionListing.findIndex(
          ({id}) => id === positionId
        )
        vm.positionListing[updatePositionIndex] = formatUpdatedPosition[0]
        vm.gridOptions.api.updateRowData({update: formatUpdatedPosition})

        updateGridGroupPipeline()
      })

      socket.on('EMPLOYER_UPDATE', async employerId => {
        if (
          vm.positionListing.some(
            position => position.employerId === employerId
          )
        ) {
          const {data: updatedPositions} = await PositionApi.getPositionListing(
            {
              employerId: employerId,
            }
          )

          if (updatedPositions && updatedPositions.length > 0) {
            const formatUpdatedPosition = await setGridData(
              updatedPositions,
              vm,
              $window
            )
            formatUpdatedPosition.forEach(position => {
              const index = vm.positionListing.findIndex(
                ({id}) => id === position.id
              )
              vm.positionListing[index] = position
            })

            vm.gridOptions.api.updateRowData({update: formatUpdatedPosition})
            updateGridGroupPipeline()
          }
        }
      })

      socket.on('APPLICATION_CREATE', async applicationId => {
        const {
          data: applicationCreated,
        } = await ApplicationsApi.getApplicationById(applicationId)
        const updatedPositionIndex = vm.positionListing.findIndex(
          ({id}) => id === applicationCreated.positionId
        )

        vm.positionListing[updatedPositionIndex].appliedJobsCount =
          Number.parseInt(
            vm.positionListing[updatedPositionIndex].appliedJobsCount,
            10
          ) + 1

        vm.gridOptions.api.updateRowData({
          update: [...vm.positionListing[updatedPositionIndex]],
        })

        updateGridGroupPipeline()
      })

      socket.on('POSITION_DELETE', async positionId => {
        const deletedPosition = vm.positionListing.filter(
          ({id}) => id === positionId
        )
        vm.positionListing = vm.positionListing.filter(
          ({id}) => id !== positionId
        )
        vm.gridOptions.api.updateRowData({remove: deletedPosition})
        $rootScope.$broadcast('position-deleted', {
          positionDeleted: positionId,
        })
        updateGridGroupPipeline()
      })
      const dateFilterParameters = {
        suppressAndOrCondition: true,
        inRangeInclusive: true,
        comparator: function(filterLocalDateAtMidnight, cellValue) {
          const dateAsString = moment(cellValue).format('DD/MM/YYYY')
          const dateParts = dateAsString.split('/')
          const cellDate = new Date(
            Number(dateParts[2]),
            Number(dateParts[1]) - 1,
            Number(dateParts[0])
          )

          if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
            return 0
          }

          if (cellDate < filterLocalDateAtMidnight) {
            return -1
          }

          if (cellDate > filterLocalDateAtMidnight) {
            return 1
          }
        },
      }

      // eslint-disable-next-line unicorn/consistent-function-scoping
      function renderDateColumn(parameters) {
        return parameters.value
          ? `<span>` + moment(parameters.value).format('DD-MM-YYYY') + `</span>`
          : ' '
      }

      const columnDefs = [
        {
          columnGroupShow: undefined,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          width: 60,
          filter: false,
          resizable: false,
        },
        {
          headerName: 'Employer Details',
          children: [
            {
              headerName: '',
              columnGroupShow: undefined,
              field: '',
              filter: false,
              width: 60,
              resizable: false,
              cellRenderer: parameters => {
                return parameters.data.archive
                  ? `<center class=""><i class="fa fa-pencil disabled-icon"></i></center>`
                  : `<center class=""><i class="fa fa-pencil pointer"></i></center>`
              },
              onCellClicked: openEditPositionModal,
            },
            {
              headerName: '',
              columnGroupShow: undefined,
              field: '',
              filter: false,
              resizable: false,
              width: 60,
              cellStyle: {background: '#95288f !important', color: '#fff'},
              cellRenderer: () => {
                return `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                style="height: 22px;width: 22px;margin: 12px -5px;" viewBox="0 0 614.9 540" style="enable-background:new 0 0 614.9 540;" xml:space="preserve">
               <style type="text/css">
                 .pt0{fill:#ffffff;}
               </style>
               <g>
                 <circle class="pt0" cx="282.2" cy="206.9" r="67.3"/>
                 <path class="pt0" d="M562.6,472.1l-87.8-87.8l3.5-5.1c28-40.4,42.2-86.1,42.2-135.7c0-32.3-6.4-63.6-18.9-93
                   c-12.5-29.5-29.7-55.3-51-76.6c-21.3-21.3-47.1-38.5-76.6-51C344.6,10.3,313.3,4,281,4c-32.3,0-63.6,6.4-93,18.9
                   c-29.5,12.5-55.3,29.7-76.6,51C90,95.2,72.9,121,60.3,150.5c-12.5,29.5-18.9,60.8-18.9,93c0,32.3,6.4,63.6,18.9,93
                   c12.5,29.5,29.7,55.3,51,76.6c21.3,21.3,47.1,38.5,76.6,51c29.5,12.5,60.8,18.9,93,18.9c49.7,0,95.3-14.2,135.7-42.2l5-3.5
                   l87.9,87.5c7.2,7.6,15.5,11.1,26.3,11.1c10.1,0,18.9-3.8,26.4-11.2c7.4-7.4,11.2-16.3,11.2-26.4
                   C573.5,488.2,569.8,479.3,562.6,472.1z M397.2,359.7c-0.8,0.8-1.6,1.6-2.5,2.4C363.2,392.6,324.9,408,281,408
                   c-43.2,0-80.9-14.9-112.2-44.4c-1.6-1.5-2.8-2.7-4.1-3.9c-32-32-48.3-71.1-48.3-116.2c0-45.1,16.2-84.2,48.3-116.2
                   c32-32,71.1-48.3,116.2-48.3c45.1,0,84.2,16.2,116.2,48.3c32,32,48.3,71.1,48.3,116.2C445.5,288.6,429.2,327.7,397.2,359.7z"/>
                 <path class="pt0" d="M281.7,387.1c1.6,0,3.3,0,4.9-0.1c-1.7,0.1-3.5,0.1-5.3,0.1C281.5,387.1,281.6,387.1,281.7,387.1z"/>
                 <path class="pt0" d="M380.4,333.5c-22.2-30.1-57.9-49.6-98.2-49.6c-40.5,0-76.4,19.8-98.6,50.2c23,28.6,58.3,47,97.8,47.1
                   c1.7,0,3.4,0,5-0.1C324.5,379.6,358.2,361.4,380.4,333.5z"/>
               </g>s
               </svg>`
              },
              onCellClicked: matchingLawyerClicked,
            },
            {
              headerName: 'Employer',
              field: 'employer.name',
              columnGroupShow: undefined,
              cellRenderer: parameters => {
                return parameters.data.employer.picSrc
                  ? `<img src=` +
                      parameters.data.employer.picSrc +
                      ` style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ` +
                      parameters.value +
                      `</span>`
                  : `<img src="/images/firmlogo_Default.png" style="width: 25px;height:25px; border-radius:50%;margin-right: 5px;margin-bottom: 3px;" alt="pic"><span> ` +
                      parameters.value +
                      `</span>`
              },
            },
            {
              headerName: 'Employer ID',
              field: 'employerId',
            },
            {
              headerName: 'Employer Selectivity',
              field: 'employer.selectivity',
            },
            {
              headerName: 'Employer Type',
              field: 'employerType',
              rowGroupIndex: 0,
            },
            {
              headerName: 'Employer Agent',
              field: 'employerAgentEmail',
            },
            {
              headerName: 'Employer Visibility',
              field: 'employer.isVisible',
            },
          ],
        },
        {
          headerName: 'Position Details',
          children: [
            {
              headerName: 'Position Title',
              field: 'title',
              filter: 'agTextColumnFilter',
              cellRenderer: parameters => {
                return parameters.value
                  ? `<span class="text-info pointer"/>${parameters.value}</span>`
                  : ``
              },
              onCellClicked: openPositionDetailModal,
              columnGroupShow: undefined,
            },
            {
              headerName: 'Req. PQE',
              width: 125,
              field: 'rPQE',
              columnGroupShow: undefined,
            },
            {
              headerName: 'Location',
              field: 'locationsName',
              cellRenderer: parameters => {
                return getLocationsTags(parameters.data.locations)
              },
            },
            {
              headerName: 'Practice Areas',
              field: 'specialtiesName',
              filter: undefined,
            },

            {
              headerName: 'Contract',
              field: 'contractType',
              rowGroupIndex: 2,
              cellRenderer: parameters => {
                return ` <li class="label label-info text-uppercase margin-r5 position-contract-type-tag">
                    ${parameters.value}
                  </li> `
              },
            },
            {
              headerName: 'Occupation',
              field: 'occupation',
              rowGroupIndex: 1,
              cellRenderer: parameters => {
                return ` <li class="label label-info text-uppercase margin-r5 position-occupation-tag">
                    ${parameters.value}
                  </li> `
              },
            },
            {
              headerName: 'Source/External Link',
              field: 'externalUrl',
              filter: false,
              cellRenderer: parameters => {
                let jobUrl = parameters.value
                  ? parameters.value.match(/http/)
                    ? parameters.value
                    : 'http://'.concat(parameters.value)
                  : parameters.value
                return parameters.value
                  ? `<span class="text-info pointer"/><a style="color:#4c9bda" href=${jobUrl} target="_blank"/>${parameters.value}</span>`
                  : ``
              },
            },
          ],
        },
        {
          headerName: 'Listing Details',
          children: [
            {
              headerName: 'Lexstep Position ID',
              field: 'id',
              columnGroupShow: undefined,
              filter: 'agTextColumnFilter',
            },
            {
              headerName: 'Current Stage',
              width: 125,
              field: 'activeStage',
              columnGroupShow: undefined,
            },
            {
              headerName: 'Furthest Stage',
              width: 125,
              field: 'positionStatus',
              columnGroupShow: undefined,
            },
            {
              headerName: '# Applicants',
              field: 'appliedJobsCount',
            },
            {
              headerName: 'Listing Type',
              columnGroupShow: undefined,
              field: 'type',
            },
            {
              headerName: 'Position Visibility',
              field: 'visible',
            },
            {
              headerName: 'Created',
              field: 'created',
              cellRenderer: renderDateColumn,
              filter: 'agDateColumnFilter',
              filterParams: dateFilterParameters,
            },
            {
              headerName: 'Expired',
              field: 'expiresAt',
              onCellDoubleClicked: openExpiryDateModal,
              cellRenderer: renderDateColumn,
              filter: 'agDateColumnFilter',
              filterParams: dateFilterParameters,
              cellClass: 'cellEditable',
            },
            {
              headerName: 'Status',
              field: 'status',
              columnGroupShow: undefined,
              cellRenderer: 'statusCellRenderer',
              onCellValueChanged: onStatusChange,
              editable: true,
              cellClass: 'cellEditable',
              cellEditor: 'agRichSelectCellEditor',
              cellEditorParams: {
                values: ['Active', 'Expired'],
                cellRenderer: 'statusCellRenderer',
              },
            },
          ],
        },
      ]

      const gridOptions = {
        defaultColDef: {
          sortable: true,
          filter: true,
          enablePivot: true,
          enableRowGroup: true,
          enableValue: true,
          columnGroupShow: 'open',
          resizable: true,
          menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
        },
        groupRowRenderer: 'agGroupCellRenderer',
        groupRowRendererParams: {
          checkbox: true,
        },
        floatingFilter: true,
        groupDefaultExpanded: -1,
        groupUseEntireRow: true,
        columnDefs: columnDefs,
        animateRows: true,
        getRowNodeId: function(data) {
          return data.id
        },
        enableCellChangeFlash: true,
        groupSelectsChildren: true,
        rowData: vm.positionListing,
        rowSelection: 'multiple',
        rowMultiSelectWithClick: true,
        rowGroupPanelShow: 'always',
        pivotPanelShow: 'always',
        groupSelectsFiltered: true,
        onFilterChanged: onFilterChanged,
        onSelectionChanged: onSelectionChanged,
        onGridReady: function() {
          initializePositionListing()
        },

        sideBar: {
          toolPanels: ['columns', 'filters'],
          defaultToolPanel: false,
        },
        statusBar: {
          statusPanels: [
            {statusPanel: 'agTotalRowCountComponent', align: 'left'},
            {statusPanel: 'agFilteredRowCountComponent', align: 'left'},
            {statusPanel: 'agSelectedRowCountComponent'},
            {statusPanel: 'agAggregationComponent'},
          ],
        },
        components: {
          statusCellRenderer: StatusCellRenderer,
        },
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Please wait while your data is loading</span>',
        suppressCopyRowsToClipboard: true,
        enableRangeSelection: true,
        enableCharts: true,
        onColumnRowGroupChanged: updateGridGroupPipeline,
        getContextMenuItems,
      }

      vm.gridOptions = gridOptions

      vm.loadPositionListing = async positionListingRecords => {
        if (positionListingRecords.status === 200) {
          vm.positionListing = await setGridData(
            positionListingRecords.data,
            vm,
            $window
          )
          vm.gridOptions.api.setRowData(vm.positionListing)

          updateGridGroupPipeline()
        } else {
          vm.changeStatus(positionListingRecords.status)
        }
      }

      const employerModal = () => {
        const modalInstance = $uibModal.open({
          templateUrl: 'create-update-employer-modal.html',
          windowClass: 'app-firm-window',
          controller: 'CreateUpdateEmployerModalController',
          controllerAs: 'ctrl',
          resolve: {
            selectedEmployerId: function() {},
          },
        })
        modalInstance.result.then(
          result => {
            const {employer} = result
            modalInstance.dismiss('cancel')
            logger.notify(
              'success',
              `Employer Id: ${employer.id} ${employer.name} created successfully`
            )
          },
          () => {}
        )
      }

      function openAddEmployerPage() {
        $window.open('/admin/firm-management?action=add', '_blank')
      }

      function openInactivePositions() {
        $window.open('/admin/inactive-positions', '_blank')
      }

      const positionModal = id => {
        const modalInstance = $uibModal.open({
          templateUrl: 'create-update-position-modal.html',
          windowClass: 'app-firm-window',
          controller: 'CreateUpdatePositionModalController',
          controllerAs: 'ctrl',
          resolve: {
            selectedPositionId: function() {
              return id
            },
            adminId: function() {
              return vm.user.id
            },
          },
        })
        modalInstance.result.then(
          _position => {
            modalInstance.dismiss('cancel')
          },
          () => {}
        )
      }

      // Function openAddPositionPage() {
      //   $window.open('/admin/job-creation', '_blank')
      // }

      function openEditPositionModal(parameter) {
        if (parameter.data.id) {
          positionModal(parameter.data.id)
        }
      }

      function openPositionDetailModal(parameter) {
        if (parameter.data) {
          positionDetailModal(parameter.data)
        }
      }

      const positionDetailModal = position => {
        $uibModal.open({
          templateUrl: 'position-details-modal.html',
          windowClass: 'position-modal-window',
          controller: 'PositionDetailsController',
          controllerAs: 'ctrl',
          resolve: {
            position: function() {
              return position
            },
            listingName: function() {
              return vm.gridName
            },
          },
        })
      }

      function openExpiryDateModal(parameter) {
        vm.dateModal = {
          title: 'Expiry Date',
          date: parameter.data.expiresAt,
        }
        const modalInstance = $uibModal.open({
          templateUrl: 'date-modal.html',
          controller: 'DateModalController',
          controllerAs: 'ctrl',
          resolve: {
            selectedModal: function() {
              return vm.dateModal
            },
            id: function() {
              return parameter.data.id
            },
          },
        })
        modalInstance.result.then(
          async selectedDate => {
            if (selectedDate.date === vm.dateModal.date) {
              logger.notify('warning', 'Same Date not updated.')
            } else if (!selectedDate.date) {
              logger.notify('warning', 'Date is empty.')
            } else if (selectedDate.date !== vm.dateModal.date) {
              if (
                new Date(selectedDate.date).setHours(0, 0, 0, 0) ===
                new Date(parameter.data.created).setHours(0, 0, 0, 0)
              ) {
                selectedDate.date = new Date(parameter.data.created).setMinutes(
                  new Date(parameter.data.created).getMinutes() + 1
                )
              }

              if (selectedDate.date < new Date())
                parameter.data.status = 'Expired'
              else parameter.data.status = 'Active'
              updateExpiryDate(
                parameter.data,
                selectedDate.date,
                vm.dateModal.title
              )
            }
          },
          () => {}
        )
      }

      const updateExpiryDate = async (row, date, title) => {
        try {
          const {data, status} = await PositionApi.updatePositionById(row.id, {
            expiresAt: date,
          })
          if (status === 200) {
            logger.notify(
              'success',
              `Position Id: ${data.id} ${title} updated successfully`
            )
            row.expiresAt = data.expiresAt
            vm.gridOptions.api.updateRowData({update: [row]})
          }
        } catch (error) {
          logger.notify('error', error.data.message)
        }
      }

      function onStatusChange(parameter) {
        if (parameter.newValue !== parameter.oldValue) {
          // eslint-disable-next-line unicorn/no-null
          let expiryDate = null
          if (parameter.newValue === 'Expired')
            expiryDate = new Date(parameter.data.created).setMinutes(
              new Date(parameter.data.created).getMinutes() + 1
            )
          parameter.data.status = parameter.newValue
          updateExpiryDate(parameter.data, expiryDate, 'Status')
        }
      }

      function onFilterChanged() {
        vm.filterCount = Object.keys(vm.gridOptions.api.getFilterModel()).length
        let filterTextBoxValue = document.querySelector('#filter-text-box')
          .value
        if (filterTextBoxValue.length > 0) {
          vm.filterCount += 1
        }

        let temporaryFilter = JSON.stringify({
          status: {values: ['Active'], filterType: 'set'},
        })

        if (
          JSON.stringify(vm.gridOptions.api.getFilterModel()) === '{}' ||
          JSON.stringify(vm.gridOptions.api.getFilterModel()) ===
            temporaryFilter
        ) {
          $log.debug(
            'onFilterChanged',
            JSON.stringify(vm.gridOptions.api.getFilterModel())
          )
          vm.showClearFilter = false
        } else vm.showClearFilter = true
        updatePipelineCountFromGrid()
      }

      // TODO: on grid functionality
      function updatePipelineCountFromGrid() {
        vm.gridOptions.api.forEachNode(node => {
          if (node.key) {
            vm.groupList.map(row => {
              if (row.id === node.id) {
                row.applicationsCount = node.allChildrenCount
                return row
              }

              return row
            })
          }
        })
        $scope.$applyAsync()
      }

      // TODO: on grid action items functionality
      function updateGridGroupPipeline() {
        vm.groupList = []

        vm.gridOptions.api.forEachNode(node => {
          if (node.key) {
            let hasChild = true
            if (
              _.isEmpty(node.childrenMapped) ||
              'undefined' in node.childrenMapped
            )
              hasChild = false
            vm.groupList.push({
              name: node.key,
              applicationsCount: node.allChildrenCount,
              color: node.leafGroup
                ? '#' + Math.trunc(Math.random() * 0xffffff).toString(16)
                : lighten('#5e5e5e', (node.level + 1) * 10),
              id: node.id,
              intId: Number(node.id) * -1,
              level: node.level,
              parentID: node.parent.id,
              hasChild: hasChild,
              isHidden: node.level !== 0,
            })
          }
        })
        $log.debug('vm.groupList', vm.groupList)
        $scope.$applyAsync()
      }

      function onSelectionChanged() {
        vm.selectedRows = vm.gridOptions.api.getSelectedRows()
        vm.selectedRowsLength = vm.selectedRows.length
        hideShowDropdownActionItem()
      }

      vm.editPositionModal = selectedRow => {
        const id = selectedRow.map(({id}) => id).join()
        positionModal(id)
      }

      vm.openMatchesTab = tabData => {
        if (tabData.employerId)
          $window.open(
            `/admin/matching-lawyers?positionId=${tabData.positionId}&employerId=${tabData.employerId}&tab=${tabData.tab}`,
            '_blank'
          )
        else
          $window.open(
            `/admin/matching-lawyers?positionId=${tabData.positionId}&tab=${tabData.tab}`,
            '_blank'
          )
      }

      vm.multipleUpdateExpiryDate = selectedRows => {
        vm.dateModal = {
          title: 'Expiry Date',
          date: '',
        }
        const modalInstance = $uibModal.open({
          templateUrl: 'date-modal.html',
          controller: 'DateModalController',
          controllerAs: 'ctrl',
          resolve: {
            selectedModal: function() {
              return vm.dateModal
            },
            id: function() {
              return selectedRows.map(row => {
                return {id: row.id}
              })
            },
          },
        })
        modalInstance.result.then(
          async selectedDate => {
            if (selectedDate.date) {
              if (
                new Date(selectedDate.date).setHours(0, 0, 0, 0) ===
                new Date().setHours(0, 0, 0, 0)
              ) {
                selectedDate.date = new Date()
              }

              const payload = selectedRows.map(row => {
                return {
                  id: row.id,
                  editPositionDto: {
                    expiresAt: selectedDate.date,
                  },
                }
              })
              try {
                const {status} = await PositionApi.updateMultiplePositions(
                  payload
                )
                if (status === 200) {
                  logger.notify(
                    'success',
                    `Multiple Expiry Date updated successfully`
                  )

                  selectedRows.map(row => {
                    row.expiresAt = selectedDate.date
                    row.status =
                      selectedDate.date < new Date() ? 'Expired' : 'Active'
                    return row
                  })

                  vm.gridOptions.api.updateRowData({update: selectedRows})
                }
              } catch (error) {
                logger.notify('error', error.data.message)
              }
            }
          },
          () => {}
        )
      }

      vm.openClonePositions = async (selectedRows, event) => {
        event.preventDefault()
        event.stopPropagation()
        console.debug('openClonePositions', selectedRows)
        if (!selectedRows || selectedRows.length === 0) {
          return
        }

        const getData = async () => {
          const requestParams = {
            params: {
              ids: selectedRows.map(({id}) => id),
              only: ['description'],
            },
          }

          console.debug('clone position request params:', requestParams)

          const response = await PositionApi.getAllPositions(requestParams)

          const positionData = response.data.positions

          console.debug('got position data:', positionData)

          if (!positionData || positionData.length === 0) {
            console.error('no position data was retrieved')
          }

          const withData = selectedRows.map(item => {
            return _.extend(
              item,
              positionData.find(data => {
                return data.id === item.id
              })
            )
          })
          console.debug('withData:', withData)
          return withData
        }

        const withData = await wrap(getData)

        let clonePositionData = {
          positions: withData,
          selectOnReset: true,
          allPracticeArea: vm.onlyParentPracticeAreaList,
          allLocations: vm.locationsList,
          allOccupations: vm.occupationList,
          allContractType: vm.contractTypesList,
        }

        const modalInstance = $uibModal.open({
          templateUrl: 'clone-position-modal.html',
          controller: 'ClonePositionController',
          controllerAs: 'ctrl',
          resolve: {
            cloningData: function() {
              return clonePositionData
            },
          },
        })
        modalInstance.result.then(
          () => {},
          () => {}
        )
      }

      const hideShowDropdownActionItem = () => {
        vm.gridDataActions = undefined
        vm.multiSelectOptions = undefined
        vm.multipleSelectionActions = undefined
        if (vm.selectedRowsLength > 0) {
          let row = vm.gridOptions.api.getSelectedRows()
          vm.multiSelectOptions = [
            {
              count: vm.selectedRowsLength,
            },
            {
              funcName: 'Clear Selection',
              function: vm.clearSelection,
            },
          ]
          vm.multipleSelectionActions = [
            {
              funcName: 'Edit Expiry Date',
              function: vm.multipleUpdateExpiryDate,
              funcParameter: row,
              visible: true,
              icon: `/images/history-clock-button.svg`,
            },
            {
              funcName: 'Clone Position',
              function: vm.openClonePositions,
              visible: true,
              funcParameter: row,
              icon: `/images/clone-position.svg`,
            },
          ]
          vm.gridDataActions = [
            {
              count: vm.selectedRowsLength,
            },
            {
              funcName: 'Edit Position',
              function: vm.editPositionModal,
              funcParameter: row,
              visible: vm.selectedRowsLength === 1,
              icon: '/images/edit-pencil.svg',
            },
            {
              funcName: 'View Position',
              function: vm.openMatchesTab,
              visible: vm.selectedRowsLength === 1,
              funcParameter: {
                positionId: row[0].id,
                tab: 3,
                employerId: row[0].employerId,
              },
              icon: `/images/view-position.svg`,
            },
            {
              funcName: 'Scout Matches',
              function: vm.openMatchesTab,
              visible: vm.selectedRowsLength === 1,
              funcParameter: {
                positionId: row[0].id,
                tab: 1,
                employerId: row[0].employerId,
              },
              icon: `/images/Matches.svg`,
            },
            {
              funcName: 'Interest in Position',
              function: vm.openMatchesTab,
              visible: vm.selectedRowsLength === 1,
              funcParameter: {
                positionId: row[0].id,
                tab: 2,
                employerId: row[0].employerId,
              },
              icon: `/images/Applications.svg`,
            },
          ]
          $scope.$applyAsync()
        }

        $scope.$applyAsync()
      }

      function getContextMenuItems() {
        var result = [
          {
            name: 'Expand All Columns',
            action: function() {
              var columnApi = vm.gridOptions.columnApi.getColumnGroupState()
              columnApi.forEach(item => {
                vm.gridOptions.columnApi.setColumnGroupOpened(
                  item.groupId,
                  true
                )
              })
            },
          },
          {
            name: 'Collapse All Columns',
            action: function() {
              var columnApi = vm.gridOptions.columnApi.getColumnGroupState()
              columnApi.forEach(item => {
                vm.gridOptions.columnApi.setColumnGroupOpened(
                  item.groupId,
                  false
                )
              })
            },
          },
          'separator',
          'copy',
          'copyWithHeaders',
          'separator',
          'chartRange',
        ]

        vm.isExportAllowed = vm.user.roles.some(
          role => role.id === 'admin' || role.id === 'ops'
        )
        if (vm.isExportAllowed) result.push('export')
        return result
      }

      function matchingLawyerClicked(parameters) {
        if (parameters.data.id) {
          $window.open(
            `/admin/matching-lawyers?positionId=${parameters.data.id}&employerId=${parameters.data.employerId}`,
            '_blank'
          )
        }
      }

      // eslint-disable-next-line unicorn/consistent-function-scoping
      function StatusCellRenderer() {}
      StatusCellRenderer.prototype.init = parameters => {
        vm.eGui = document.createElement('div')
        let color = 'Red'
        if (parameters.value === 'Active') {
          color = 'Yellow'
        }

        vm.eGui.innerHTML =
          '<span style="display:inline-block;margin-bottom:-2px;width:15px;height:15px;background:' +
          color +
          ';border-radius:20px;"> </span>' +
          '<span> ' +
          parameters.value +
          '</span>'
      }

      StatusCellRenderer.prototype.getGui = () => {
        return vm.eGui
      }

      vm.gridName = 'position'
      vm.filterCount = 0
      vm.helpTooltip = {
        name: 'Help',
        content: $sce.trustAsHtml(positionHelpContent),
      }

      vm.actionsFunctions = [
        {
          funcName: 'Show Inactive Positions',
          leftClick: openInactivePositions,
        },
        {
          funcName: 'Add Employer',
          leftClick: employerModal,
        },
      ]
      vm.activeActions = [
        {
          funcName: 'Add Position',
          function: positionModal,
          visible: true,
          icon: `/images/plus-icon.svg`,
        },
      ]

      vm.sliderFilter = filterPqe => {
        let separator = filterPqe.pqe.search(';')
        let minPQE = Number(filterPqe.pqe.slice(0, separator))
        let maxPQE = Number(
          filterPqe.pqe.slice(separator + 1, filterPqe.pqe.length)
        )
        if (maxPQE === 11) maxPQE = 50
        if (minPQE === -2) minPQE = -20
        let range = _.range(minPQE, maxPQE + 0.5, 0.5)
        let filterValues = range.map(element => String(element))
        let currentActiveFilters = vm.gridOptions.api.getFilterModel()
        if (maxPQE === 50 && minPQE === -20) {
          delete currentActiveFilters.rPQE
          gridOptions.api.setFilterModel(currentActiveFilters)
        } else {
          currentActiveFilters.rPQE = {
            values: filterValues,
            filterType: 'set',
          }
          gridOptions.api.setFilterModel(currentActiveFilters)
        }

        $scope.$applyAsync()
      }

      // vm.loadExpiredPositions = async totalExpiredPositionCount => {
      //   vm.expiredPositionListing = []
      //   const offset = 0
      //   const footer = document
      //     .querySelector(`#${vm.gridName}`)
      //     .querySelector(`.ag-status-bar-center`)
      //   footer.innerHTML = `<div style="text-align: center;align-self: center; display: flex;">
      //                         <div class="agGridLoader"></div>
      //                         <span style="padding-left: 15px">Loading Expired Positions </span>
      //                       </div> `

      //   await new Promise((resolve, reject) =>
      //     getExpiredPosition(resolve, reject, offset, totalExpiredPositionCount)
      //   )
      //   $rootScope.$broadcast('listing-loaded')
      //   footer.innerHTML = `<div style="text-align: center;align-self: center; display: flex;">
      //         <i class="fa fa-check" style="font-size:20px; color:green" aria-hidden="true"></i>
      //         <span style="padding-left: 15px" align-self: center;">Loaded Expired Positions Successfully</span>
      //         </div>`

      //   vm.positionListing.push(...vm.expiredPositionListing)
      //   const existingFilters = vm.gridOptions.api.getFilterModel()
      //   if (Object.keys(existingFilters).length === 0) {
      //     const filter = {
      //       status: {values: ['Active'], filterType: 'set'},
      //     }
      //     vm.gridOptions.api.setFilterModel(filter)
      //   }

      //   updateGridGroupPipeline()
      //   $timeout(() => {
      //     footer.innerHTML = ''
      //   }, 1500)
      // }

      // const getExpiredPosition = async (
      //   resolve,
      //   reject,
      //   offset,
      //   totalExpiredPositionCount
      // ) => {
      //   const payload = {active: false, limit: 10000}
      //   payload.offset = offset
      //   const {
      //     data: expiredPositionList,
      //   } = await PositionApi.getPositionListing(payload)

      //   if (
      //     offset <= totalExpiredPositionCount &&
      //     $location.url().contains('admin/admin-listings')
      //   ) {
      //     offset += payload.limit
      //     getExpiredPosition(resolve, reject, offset, totalExpiredPositionCount)
      //     const expiredPosition = await setGridData(
      //       expiredPositionList,
      //       vm,
      //       $window
      //     )
      //     vm.expiredPositionListing.push(...expiredPosition)

      //     vm.gridOptions.api.updateRowData({add: expiredPosition})
      //   } else {
      //     return resolve()
      //   }
      // }

      const initializePositionListing = async () => {
        vm.user = await userService.getUser()

        const [
          {data: locationsList},
          {data: contractTypeList},
          {data: occupationList},
          {data: legalPracticeAreaList},
          {data: legalEmployerTypeList},
          {data: candidateAgents},
          activePositionListingRecords,
          {data: expiredPositionListingCount},
        ] = await Promise.all([
          SharedApi.getAllLocations({
            supported: true,
            regions: true,
          }),
          SharedApi.getAllContractTypes(),
          SharedApi.getAllOccupations(),
          SharedApi.getCategoryById(1),
          SharedApi.getCategoryById(2),
          CandidateProfileApi.getAdminAndCorporateUsers(),
          PositionApi.getPositionListing({active: true}),
          PositionApi.getPositionListing({active: false, count: true}),
        ])

        vm.candidateAgentsList = candidateAgents
        vm.contractTypesList = contractTypeList
        vm.occupationList = occupationList
        vm.legalPracticeAreaList = legalPracticeAreaList
        vm.legalEmployerTypeList = legalEmployerTypeList
        vm.locationsList = locationsList

        vm.onlyParentPracticeAreaList = vm.legalPracticeAreaList.specialties.filter(
          ({parentId}) => parentId === null
        )
        vm.gridActionsDirective = {
          // PqeSlider: {
          //   function: vm.sliderFilter,
          //   params: {
          //     options: {
          //       round: 1,
          //       from: -2,
          //       to: 11,
          //       step: 0.5,
          //       dimension: ' years',
          //       scale: ['≤-2', -1, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, '≥11'],
          //     },
          //     filterPQE: {
          //       pqe: '-2;11',
          //     },
          //   },
          //   buttonId: 'lawyer-listing-pqe-slider',
          //   icon: 'images/stage.svg',
          // },
          practices: {
            buttonId: 'position-listing-filter-prac',
            allPracticeAreaList: vm.onlyParentPracticeAreaList,
            iconLabel: 'Filter by Practice Area',
          },
        }
        vm.loadPositionListing(activePositionListingRecords)
        // vm.loadExpiredPositions(expiredPositionListingCount)
      }
    },
  ])
})()

const addLight = (color, amount) => {
  let cc = Number.parseInt(color, 16) + amount
  let c = cc > 255 ? 255 : cc
  c = c.toString(16).length > 1 ? c.toString(16) : `0${c.toString(16)}`
  return c
}

const lighten = (color, amount) => {
  color = color.includes('#') ? color.slice(1, color.length) : color
  // eslint-disable-next-line radix
  amount = Number.parseInt((255 * amount) / 100)
  color = `#${addLight(color.slice(0, 2), amount)}${addLight(
    color.slice(2, 4),
    amount
  )}${addLight(color.slice(4, 6), amount)}`
  return color
}

const getLocationsTags = positionLocations => {
  let locationTags = ``
  if (positionLocations && positionLocations.length > 0) {
    positionLocations.forEach(positionLocation => {
      locationTags += ` <li class="label text-uppercase margin-r5 location-${positionLocation.color}" >
          ${positionLocation.name}
        </li> `
    })
  }

  return locationTags
}

const setGridData = (allPositionRecord, vm) => {
  return Promise.all(
    allPositionRecord.map(async data => {
      if (data.employer) setEmployerForPositionListing(data, vm)
      data.locations =
        data.locations.length > 0
          ? vm.locationsList
              .filter(({id}) =>
                data.locations.find(location => location.id === id)
              )
              .map(location => ({
                id: location.id,
                name: location.name,
                parent: location.parent,
                color: location.country.region.color,
              }))
          : []
      data.locationsName =
        data.locations.length > 0
          ? data.locations.map(location => location.name)
          : []
      data.specialties =
        data.specialties.length > 0
          ? vm.legalPracticeAreaList.specialties.filter(({id}) =>
              data.specialties.find(specialty => specialty.id === id)
            )
          : []
      data.specialtiesName =
        data.specialties.length > 0
          ? data.specialties.map(practiceArea => practiceArea.name)
          : []

      data.contractType =
        data.contractTypeId !== null || data.contractTypeId !== undefined
          ? vm.contractTypesList.find(
              contract => contract.id === data.contractTypeId
            ).name
          : ''
      data.occupation = data.occupationId
        ? vm.occupationList.find(
            occupation => occupation.id === data.occupationId
          ).name
        : ''
      data.rPQE = `${
        data.lawPreferences.minPqe <= 0 ? 'NQ' : data.lawPreferences.minPqe
      }${
        data.lawPreferences.maxPqe === 11
          ? '+'
          : data.lawPreferences.maxPqe <= 0 ||
            data.lawPreferences.maxPqe === data.lawPreferences.minPqe
          ? ''
          : '-' + data.lawPreferences.maxPqe.toString()
      }`
      data.visible = data.visible ? 'Visible' : 'Invisible'
      data.status = data.expiresAt
        ? new Date(data.expiresAt).setHours(0, 0, 0, 0) <=
          new Date().setHours(0, 0, 0, 0)
          ? 'Expired'
          : 'Active'
        : 'Active'
      return data
    })
  )
}

const setEmployerForPositionListing = (data, vm) => {
  let employerSelectivity = ''

  if (data.employer.selectivity) {
    for (let index = 1; index <= data.employer.selectivity; index++) {
      employerSelectivity += '$'
    }
  }

  if (data.employer.selectivity === 0) employerSelectivity = 'Uncategorized'

  if (data.employer.logo)
    data.employer.picSrc = `${process.env.PUBLIC_BUCKET_URL}/employers/${data.employerId}/logo/${data.employer.logo}`

  data.employer.selectivity = employerSelectivity
  data.employerAgentEmail = data.employer.agentId
    ? vm.candidateAgentsList.find(agent => agent.id === data.employer.agentId)
      ? vm.candidateAgentsList.find(agent => agent.id === data.employer.agentId)
          .email
      : 'unassigned'
    : 'unassigned'
  data.employer.isVisible = data.employer.isVisible ? 'Visible' : 'Invisible'
  data.employerType =
    data.employerType.length > 0
      ? vm.legalEmployerTypeList.specialties
          .filter(({id}) =>
            data.employerType.find(employerType => employerType.id === id)
          )
          .map(employerType => employerType.name)
          .join()
      : 'Auto-Generated'
  return data
}

const positionHelpContent = `
<div>
<p>	Positions allows you to search for positions based on specific criteria you define.</p>
<b>My Employers</b>
<p>Filter by “My Employers” from the toolbar above the grid to display positions at your assigned employers only.</p>
<b>Filtering</b>
<p>The “Filter by Practice Area” icon allows you to quickly refine your search. Further filters can be applied by hovering over each column header and selecting the hamburger menu on the right.</p>
<b>Views</b>
<p>Personalise different list layouts by choosing the columns to display, adjusting their width and moving them to re-order to your preferences. You can save custom column layouts with filter criteria to easy access again later via the “Views” icon in the top right -- either as a Private “Saved View” or Shared with other team members. The Views menu includes pre-set views that filter for Private Practice and In-House positions.</p>
<b>Clear</b>
<p>When one or more filters are applied, a Clear filter icon will appear in the top right above the grid. Select to clear any applied filters and/or search and reset the grid data to default.</p>
<b>Group</b>
<p>Drag and drop columns to the grouping drop zone in the grid’s top row to group rows by a particular column.  You can Expand/Collapse All Rows from the Views icon in the top right to view positions by Group.</p>
<b>Sorting</b>
<p>Positions are sorted by Position ID in descending order, showing the latest position first by default. You can change how the list is ordered by clicking the column headers to sort. To sort by multiple columns, hold down shift while clicking the column header.</p>
<b>Position Title</b>
<p>You can quickly view more details about each position in the list by clicking its hyperlinked name to open a preview pane.</p>
<b>Status</b>
<p>The Positions grid shows Active positions only by default – i.e. those which do not have an expiry date in the past. Changing the status of a position to Archived, expires the Position with immediate effect. Use the Status column filters to view Archived positions which have expired.</p>
<b>Actions</b>
<p>Select Position Description to review employer requirements and edit.  Scout Matches to review LexStep matches and shortlist top candidates by promoting their match stage to “Scouted”, and Review Interest in Position to manage Applications.</p>
<b>Bulk Actions</b>
<p>Selecting one or more rows enables bulk actions like Edit Expiry Date and Clone which are accessible from the toolbar icons above the grid. </p>
</div> `



// WEBPACK FOOTER //
// ./scripts/admin-panel/position-listing/position-listing.ctrl.js